import { render } from "./AvatarComp.vue?vue&type=template&id=41806cb6"
import script from "./AvatarComp.vue?vue&type=script&lang=js"
export * from "./AvatarComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__